import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventService {

  constructor(private http: HttpClient) { }

  getEvents(flux?: string): Observable<any> {
    let url = environment.backEndUrl + '/events' + (flux ? `?category=${flux}` : '');;
    return this.http.get(url);
  }

  getEvent(uuid_event: string): Observable<any> {
    let url = environment.backEndUrl + `/events/${uuid_event}`;
    return this.http.get(url);
  }

  getEventSlotsByDate(uuid_event: string, date: string, uuid_passenger?: string): Observable<any> {
    let url = environment.backEndUrl + `/events/${uuid_event}/occurrences`;

    let params = new HttpParams();
    params = params.append('date', date);
    if (uuid_passenger) {
      params = params.append('uuid_user', uuid_passenger);

    }
    return this.http.get(url, { params: params });
  }
}
